import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BaseSelect from '../common/BaseSelect';
import TextArea from './TextArea';
import DurationTextArea from './DurationTextArea';
import RatingSelect from './RatingSelect';
import Label from '../common/Label';
import { PROCESS_FLOW_NOT_REQUIRED } from './redux/constants';

class QuestionInput extends PureComponent {
  static getComponentByAnswerTypeId = {
    1: TextArea,
    2: BaseSelect,
    3: DurationTextArea,
    4: RatingSelect,
  }
  static formTypeOffset = {
    1: 0,
    2: 11,
    3: 22,
  }

  // set this now to prevent dealing w/ undefined
  state = {
    parsedAnswerChoices: convertAnswerChoicesToOptionData(this.props.answerChoices),
  }

  render() {
    const { parsedAnswerChoices } = this.state;
    const {
      value,
      isDisabled,
      questionText,
      eventHandler,
      id: questionId,
      coachingFormType: { id: formTypeId },
      isErrorTriggered,
      answerType: { id: answerTypeId },
    } = this.props;
    
    // let's attempt to make these input-components duck typed--taking the same props, no matter what
    const InputComponent = QuestionInput.getComponentByAnswerTypeId[answerTypeId];
    const offset = QuestionInput.formTypeOffset[formTypeId];
    const fullLabel = answerTypeId > 2 ? `${questionText}:` : `${questionId - offset}. ${questionText}`;
    const isProcessFlow = formTypeId === 3;

    return (
      <div className={`ac-question-input ${answerTypeId === 3 ? 'is-duration' : ''}`}>
        <Label text={fullLabel} />
        <InputComponent
          hideXDelete
          value={value}
          inputKey={questionId}
          isDisabled={isDisabled}
          placeholder="- Select -"
          noErrorState={isProcessFlow && PROCESS_FLOW_NOT_REQUIRED[questionText]}
          coachingFormType={formTypeId}
          eventHandler={eventHandler}
          optionData={parsedAnswerChoices}
          isErrorTriggered={isErrorTriggered}
          outerWrapClassNames="ac-question-input__input"
          validationRules={{
            required: true,
          }}
        />
      </div>
    );
  }
}

/**
 * Converts array of strings into option data a BaseSelect component can accept
 * @param {?array} answerChoices - must be able to handle null to keep everything duck typed
 */
function convertAnswerChoicesToOptionData(answerChoices) {
  if (!answerChoices) return [];
  
  return answerChoices.map((choice) => {
    return {
      key: choice,
      text: choice,
      value: choice,
    };
  });
}

QuestionInput.propTypes = {
  isErrorTriggered: PropTypes.bool.isRequired,
  eventHandler: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  answerChoices: PropTypes.array,
  answerType: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  value: PropTypes.string.isRequired,
  questionText: PropTypes.string,
  id: PropTypes.number.isRequired,
};

QuestionInput.defaultProps = {
  answerChoices: null,
};

export default QuestionInput;



// WEBPACK FOOTER //
// ./src/features/agent-coaching/QuestionInput.js